import SocialMedia from "components/About/SocialMedia";
import HeroBusinessAdvisory from "components/BusinessAdvisory/HeroBusinessAdvisory";
import ListBusinessAdvisory from "components/BusinessAdvisory/ListBusinessAdvisory";
import MissionBusinessAdvisory from "components/BusinessAdvisory/MissionBusinessAdvisory";
import QuoteBusinessAdvisory from "components/BusinessAdvisory/QuoteBusinessAdvisory";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import React from "react";

const BusinessAdvisory = () => {
  return (
    <div>
      <HeroBusinessAdvisory />
      <QuoteBusinessAdvisory />
      <MissionBusinessAdvisory />
      <ListBusinessAdvisory />
      <PriceSection />
    </div>
  );
};

export default BusinessAdvisory;
